import { render, staticRenderFns } from "./ModalComponent.vue?vue&type=template&id=4efe939e&scoped=true&"
import script from "./modal-component.ts?vue&type=script&lang=ts&"
export * from "./modal-component.ts?vue&type=script&lang=ts&"
import style0 from "./ModalComponent.vue?vue&type=style&index=0&id=4efe939e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efe939e",
  null
  
)

export default component.exports